module.exports = __webpack_public_path__ + "img/title.7527cb94.png";